module.exports = __webpack_public_path__ + "img/Group-5125.ac23722c.svg";